/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React, {useEffect, useRef} from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const propTypes = {
  setShowOverlay: PropTypes.func.isRequired,
  videoLink: PropTypes.string.isRequired
};

const Overlay = ({
  setShowOverlay,
  videoLink
}) => {
  const videoRef = useRef();

  useEffect(() => {
    window.addEventListener("mousedown", handleOverlay);
    return () => window.removeEventListener("mousedown", handleOverlay);
  }, []);

  const handleOverlay = (event) => {
    if (!(videoRef.current.contains(event.target))) {
      setShowOverlay(false);
    }
  };

  return (
    <Wrapper>
      <Button onClick={() => setShowOverlay(false)}>
        +
      </Button>
      <Video ref={videoRef}>
        <video
          autoPlay
          controls
          className="card-video"
        >
          <source
            src={videoLink}
            type="video/mp4"
          />
          Your browser does not support HTML video.
        </video>
      </Video>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: #261E38;
  overflow: scroll;
  z-index: 999;
`;

const Video = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  .card-video {
    height: 100%;
    width: 100%;
    border: none;
  }
  @media (max-width: 768px) {
    width: 90%;
  }
`;

const Button = styled.div`
  color: #fff;
  position: fixed;
  top: 10px;
  right: 10px;
  font-weight: 600;
  cursor: pointer;
  background: 0 0;
  border: 0;
  transform: rotate(45deg);
  font-size: 60px;
  outline: 0;
  height: 50px;
  width: 40px;
`;

Overlay.propTypes = propTypes;

export default Overlay;
